import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import '../../index.css';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { PartidoService } from './PartidoService';
import { TeamService } from '../DataTables/TeamService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import useToken from '../App/useToken';
import { AutoComplete } from 'primereact/autocomplete';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import { Redirect } from 'react-router-dom';


function App() {
    return (
        <div>
            <DataTableCrudDemo />
        </div>
    );
}

const DataTableCrudDemo = () => {

    let emptyProduct = {
        teaml_id: null,
        teamv_id: null,
        fechaPartido: null,
        fase: 'grupos',
        ronda: 'grupos',
    };

    let emptyProduct1 = {
        partido_id: "",
        teamlGoles: "",
        teamvGoles: "",
    };


    const [products, setProducts] = useState(null);
    const [permisoPagina, setPermisoPagina] = useState(null);
    const [productDialog, setProductDialog] = useState(false);
    const [productDialog1, setProductDialog1] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const productService = new PartidoService();
    const teamService = new TeamService();
    const { token } = useToken();
    const [selectedCountry1, setSelectedCountry1] = useState(null);
    const [selectedCountry2, setSelectedCountry2] = useState(null);
    const [filteredCountries, setFilteredCountries] = useState(null);
    const [countries, setCountries] = useState([]);
    const [date7] = useState(null);
    const [nombreEquipoLocal, setnombreEquipoLocal] = useState(null);
    const [nombreEquipoVisitante, setnombreEquipoVisitante] = useState(null);
    const [isCorrectionResult, setIsCorrectionResult] = useState(false);

    useEffect(() => {
        productService.getPartidosList(token).then(data => {
            console.log (data);
            if (data == "Error"){
                setPermisoPagina(null);
                setProducts(null);
            }
            else{
                setPermisoPagina(true);
                setProducts(data);
            }
        });
        teamService.getTeamsList(token).then(data => setCountries(data));

    }, []);

    const openNew = () => {
        //let _product = {...product};
        setSelectedCountry1(null);
        setSelectedCountry2(null);
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(true);
        //console.log(_product);
    }

    const openNewResult = (e) => {
        const hasResult = e.teamlGoles !== null && e.teamvGoles !== null;
        setSubmitted(false);
        setIsCorrectionResult(hasResult);
        setnombreEquipoLocal(e.equipoLocal);
        setnombreEquipoVisitante(e.equipoVisitante);
        setProduct({
            partido_id: e.id,
            teamlGoles: hasResult ? Number(e.teamlGoles) : 0,
            teamvGoles: hasResult ? Number(e.teamvGoles) : 0,
        });
        setProductDialog1(true);
    }

    const hideDialog = () => {
        setSelectedCountry1(null);
        setSelectedCountry2(null);
        setSubmitted(false);
        setProductDialog(false);
        setProduct(emptyProduct);
    }

    const hideDialog1 = () => {
        setSubmitted(false);
        setProductDialog1(false);
        setIsCorrectionResult(false);
        setProduct(emptyProduct1);
    }


    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const hideDeleteProductsDialog = () => {
        setDeleteProductsDialog(false);
    }

    const saveProduct = async e => {
        setSubmitted(true);        
        let _products = [...products];
        let _product = {...product};

        if (_product.teaml_id == null || _product.teamv_id == null || _product.fechaPartido == null || _product.fase == null || _product.ronda == null ){
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Llenar todos los datos!!', life: 3000 });
        }
        else if (_product.fase === 'playoffs' && _product.ronda === 'grupos') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Selecciona la ronda del partido de playoffs', life: 3000 });
        }
        else{
            if (product.id) {
                const index = findIndexById(product.id);
                _products[index] = _product;
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Updated', life: 3000 });
            }
            else {
                let teaml_id = _product.teaml_id;
                let teamv_id = _product.teamv_id;
                let fechaPartido = formatLocalDateTime(_product.fechaPartido);
                let fase = _product.fase;
                let ronda = _product.fase === 'grupos' ? 'grupos' : _product.ronda;
                const newTeamResponse = await productService.newMatch({
                    teaml_id,
                    teamv_id,
                    fechaPartido,
                    fase,
                    ronda
                },token);
                if ( newTeamResponse.code === 200){
                    productService.getPartidosList(token).then(data => setProducts(data));
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Equipo Created', life: 3000 });
                }
                else{
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Error Al Crear Equipo', life: 3000 });
                }
                _products.push(_product);
            }
                //setProducts(_products);
            setProductDialog(false);
            setProduct(emptyProduct);
        }
    }

    const formatLocalDateTime = (date) => {
        const pad = (value) => String(value).padStart(2, '0');

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }

    // METODO PARA ENVIAR LOS RESULTADOS DE UN PARTIDO
    const saveProduct1 = async e => {
        setSubmitted(true);        
        let _product = {...product};
        if (_product.partido_id === "" || _product.teamlGoles === "" || _product.teamlGoles === null || _product.teamvGoles === "" || _product.teamvGoles === null ){
            toast.current.show({ severity: 'error', summary: 'Errores', detail: 'Llenar todos los datos!!', life: 3000 });
        }
        else{
            const confirmMessage = isCorrectionResult
                ? 'Confirmas la correccion del resultado? Esto recalculara las apuestas de este partido y actualizara todo el ranking.'
                : 'Confirmas que el resultado oficial es correcto? Esto calculara las apuestas y actualizara el ranking.';

            if (!window.confirm(confirmMessage)) {
                return;
            }

            let teamlGoles = _product.teamlGoles;
            let teamvGoles = _product.teamvGoles;
            let partido_id = _product.partido_id;
            const newTeamResponse1 = await productService.ingresarResultadosPartido({
                teamlGoles,
                teamvGoles,
                partido_id
            },token);
            if ( newTeamResponse1.code === 200){
                productService.getPartidosList(token).then(data => setProducts(data));
                toast.current.show({ severity: 'success', summary: 'Correcto', detail: newTeamResponse1.mensaje, life: 3000 });
            }
            else{
                toast.current.show({ severity: 'error', summary: 'Error al guardar resultado', detail: newTeamResponse1.mensaje, life: 3000 });
            }
            setProductDialog1(false);
            setIsCorrectionResult(false);
            setProduct(emptyProduct1);
        }
    }




    // const editProduct = (product) => {
    //     setProduct({...product});
    //     setProductDialog(true);
    // }

    // const confirmDeleteProduct = (product) => {
    //     setProduct(product);
    //     setDeleteProductDialog(true);
    // }

    const deleteProduct = () => {
        let _products = products.filter(val => val.id !== product.id);
        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const confirmDeleteSelected = () => {
        setDeleteProductsDialog(true);
    }

    const deleteSelectedProducts = () => {
        let _products = products.filter(val => !selectedProducts.includes(val));
        setProducts(_products);
        setDeleteProductsDialog(false);
        setSelectedProducts(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    }

    const onInputChange = (e, name) => {
        const val = e.value.id;//(e.target && e.target.value) || '';
        let _product = {...product};
        _product[`${name}`] = val;
        setProduct(_product);
    }

    const onInputChangeDateTime = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = {...product};
        _product[`${name}`] = val;
        setProduct(_product);
    }

    const onInputChangeNative = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = {...product};
        _product[`${name}`] = val;
        if (name === 'fase') {
            _product.ronda = val === 'grupos' ? 'grupos' : 'dieciseisavos';
        }
        setProduct(_product);
    }

    const rondaBodyTemplate = (rowData) => {
        return rondaLabel(rowData.ronda, rowData.fase);
    }

    const rondaLabel = (ronda, fase) => {
        if (fase !== 'playoffs') {
            return 'Fase de grupos';
        }

        const labels = {
            dieciseisavos: '16avos',
            octavos: '8avos',
            cuartos: '4tos',
            semifinal: 'Semifinal',
            tercer_puesto: 'Tercer puesto',
            final: 'Final',
        };

        return labels[ronda] || 'Playoffs';
    }

    const onInputChange1 = (e, name, rowData) => {
        const val = e.value;
        let _product = {...product};
        _product[`${name}`] = val;
        setProduct(_product);
        //console.log(_product);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Nuevo Partido" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} />
            </React.Fragment>
        )
    }

    const imageBodyTemplate = (rowData) => {
        let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoLocal;
        return (
            <React.Fragment>
                <img src={url} 
                    onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
                    alt={rowData.bandera} className="product-image" />
                <span className={`product-badge status-${rowData.equipoLocal.toLowerCase()}`}>{rowData.equipoLocal}</span>
            </React.Fragment>
        );
    }

    const imageVisitanteBodyTemplate = (rowData) => {
        let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoVisitante;
        return (
            <React.Fragment>
                <img src={url} 
                    onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
                    alt={rowData.banderaEquipoVisitante} className="product-image" />
                <span className={`product-badge status-${rowData.equipoVisitante.toLowerCase()}`}>{rowData.equipoVisitante}</span>
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="mx-0 my-1">Partidos</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );
    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
        </React.Fragment>
    );

    const productDialog1Footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog1} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveProduct1} />
        </React.Fragment>
    );


    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
        </React.Fragment>
    );
    const deleteProductsDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductsDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedProducts} />
        </React.Fragment>
    );

    const searchCountry = (event) => {
        setTimeout(() => {
            let _filteredCountries;
            if (!event.query.trim().length) {
                _filteredCountries = [...countries];
            }
            else {
                _filteredCountries = countries.filter((country) => {
                    return country.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
            setFilteredCountries(_filteredCountries);
        }, 250);
    }

    const itemTemplate = (item) => {
        let url = process.env.REACT_APP_URL_IMAGES+item.bandera;
        return (
            <div className="country-item">
                <img alt={item.nombre} 
                    src = {url} 
                    onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
                    className={`flag flag-${item.nombre.toLowerCase()}`} />
                <div>{item.nombre}</div>
            </div>
        );
    }

    const actionBodyTemplate = (rowData) => {
        if (rowData.teamlGoles !== null && rowData.teamvGoles !== null) {
            return (
                <React.Fragment>
                    <Button label="Corregir resultado" icon="pi pi-pencil" className="p-button-rounded p-button-warning" onClick={ () => openNewResult(rowData) } />
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <Button id={rowData.id} label="Cargar resultado" icon="pi pi-plus" className="p-button-rounded p-button-info" 
                onClick={ () => openNewResult(rowData) } />
            </React.Fragment>
        );
    }

    if ( permisoPagina === true){
        return (

            <div className="datatable-crud-demo">
                <Toast ref={toast} />

                <div className="card">
                    <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>

                    <DataTable ref={dt} value={products} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                        globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                        {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column> */}
                        <Column field="id" header="id" sortable style={{ minWidth: '12rem' , display:"none" }}></Column>
                        <Column field="equipoLocal" header="Equipo 1" body={imageBodyTemplate} sortable style={{ minWidth: '16rem' }}></Column>

                        <Column field="teamlGoles" header="L" sortable style={{ maxWidth: '6rem' }}></Column>
                        <Column field="teamvGoles" header="V" sortable style={{ maxWidth: '6rem' }}></Column>


                        <Column field="equipoVisitante" header="Equipo 2" body={imageVisitanteBodyTemplate} sortable style={{ minWidth: '16rem' }} ></Column>
                        <Column field="teaml_id" header="teaml_id" sortable style={{ minWidth: '16rem', display:"none" }}></Column>
                        <Column field="teamv_id" header="teamv_id" sortable style={{ minWidth: '16rem', display:"none" }}></Column>
                        <Column field="fechaPartido" header="Fecha Partido" sortable style={{ minWidth: '16rem' }}></Column>
                        <Column field="fase" header="Fase" sortable style={{ minWidth: '8rem' }}></Column>
                        <Column field="ronda" header="Ronda" body={rondaBodyTemplate} sortable style={{ minWidth: '9rem' }}></Column>

                        <Column field="action" header="Resultado" body={actionBodyTemplate} sortable style={{ minWidth: '10rem' }}></Column>

                    </DataTable>
                </div>

                <Dialog visible={productDialog} style={{ width: '450px' }} header="Nuevo Partido" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>

                    <div className="field">
                        <label htmlFor="Equipo 1">Equipo 1</label>
                        <AutoComplete value={selectedCountry1} 
                            suggestions={filteredCountries} 
                            completeMethod={searchCountry} 
                            field="nombre"
                            dropdown forceSelection itemTemplate={itemTemplate} 
                            onChange={(e) => setSelectedCountry1(e.value)} aria-label="Countries" 
                            onSelect={(e) => onInputChange(e, 'teaml_id')} 
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="Equipo 2">Equipo 2</label>
                        <AutoComplete value={selectedCountry2} 
                            suggestions={filteredCountries} 
                            completeMethod={searchCountry} 
                            field="nombre"
                            dropdown forceSelection itemTemplate={itemTemplate} 
                            onChange={(e) => setSelectedCountry2(e.value)} aria-label="Countries" 
                            onSelect={(e) => onInputChange(e, 'teamv_id')} 
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="fase">Fase</label>
                        <select id="fase" className="p-inputtext p-component" value={product.fase} onChange={(e) => onInputChangeNative(e, 'fase')}>
                            <option value="grupos">Fase de grupos</option>
                            <option value="playoffs">Playoffs</option>
                        </select>
                    </div>
                    {product.fase === 'playoffs' && <div className="field">
                        <label htmlFor="ronda">Ronda</label>
                        <select id="ronda" className="p-inputtext p-component" value={product.ronda} onChange={(e) => onInputChangeNative(e, 'ronda')}>
                            <option value="dieciseisavos">16avos</option>
                            <option value="octavos">8avos</option>
                            <option value="cuartos">4tos</option>
                            <option value="semifinal">Semifinal</option>
                            <option value="tercer_puesto">Tercer puesto</option>
                            <option value="final">Final</option>
                        </select>
                    </div>}
                    <div className="field">
                        <label htmlFor="Hora Partido:">Hora Partido</label>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="time24">Time / 24h</label>
                            <Calendar dateFormat="mm/dd/yy" id="time24" value={date7} onChange={(e) => onInputChangeDateTime(e,'fechaPartido')} showTime showSeconds />
                        </div>
                    </div>
                </Dialog>


                <Dialog visible={productDialog1} style={{ width: '450px' }} header={isCorrectionResult ? 'Corregir resultado' : 'Cargar resultado'} modal className="p-fluid" footer={productDialog1Footer} onHide={hideDialog1}>
                    <div className="field">
                        <label htmlFor="teamlGoles">{nombreEquipoLocal}</label>
                            <InputNumber 
                                id="teamlGoles" 
                                value={product.teamlGoles}
                                min={0} max={100} 
                                onChange={(e) => onInputChange1(e, 'teamlGoles')} 
                                required autoFocus className={classNames({ 'p-invalid': submitted && (product.teamlGoles === '' || product.teamlGoles === null) })} />
                                {submitted && (product.teamlGoles === '' || product.teamlGoles === null) && <small className="p-error">Los Goles Del Equipo Local Son Requeridos.</small>}
                    </div>
                    <div className="field">
                        <label htmlFor="teamvGoles">{nombreEquipoVisitante}</label>
                            <InputNumber 
                                id="teamvGoles" 
                                value={product.teamvGoles}
                                min={0} max={100} 
                                onChange={(e) => onInputChange1(e, 'teamvGoles')} 
                                required autoFocus className={classNames({ 'p-invalid': submitted && (product.teamvGoles === '' || product.teamvGoles === null) })} />
                                {submitted && (product.teamvGoles === '' || product.teamvGoles === null) && <small className="p-error">Los Goles Del Equipo Visitante Son Requeridos.</small>}
                    </div>
                </Dialog>



                <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                        {product && <span>Are you sure you want to delete <b>{product.name}</b>?</span>}
                    </div>
                </Dialog>

                <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                        {product && <span>Are you sure you want to delete the selected products?</span>}
                    </div>
                </Dialog>
            </div>
        );
    }
    return (
        <div>
            <h2>Opcion no permitida</h2>
        </div>
    );
}
export default App;
